import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ChainableNumberInput } from './chainable-number-input';
import { clamp } from '../helpers';
export const MinutesInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    onChange,
    onBlur,
    min = 0,
    max = 59,
    ...rest
  } = props;
  const handleBlur = event => {
    onBlur == null || onBlur(event);
    if (value) {
      onChange == null || onChange(clamp(parseInt(value, 10), min, max).toString().padStart(2, '0'));
    }
  };
  return /*#__PURE__*/React.createElement(ChainableNumberInput, _extends({
    ref: ref,
    min: min,
    max: max,
    value: value,
    onBlur: handleBlur,
    onChange: onChange
  }, rest));
});
MinutesInput.displayName = 'MinutesInput';
//# sourceMappingURL=minutes-input.js.map